import * as API from "../../utils/api"
import { GetCommodity } from "../../utils/symbol"
import { COMMODITY } from "../../config/const"
import { APIResponse } from "./types"
import {
  chartApiParamObj,
  resultObj,
} from "components/atoms/chart/logic/chartProvider"

const GetChartSession: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return API.auth_request("GET", "Message/GetChartSession", params, headers)
}

const Chart = async (
  params: chartApiParamObj,
  headers?: object
): Promise<resultObj> => {
  const { SecurityType } = params

  let url = "Message/Chart"
  // switch (GetCommodity(SecurityType)) {
  //   // 現物、信用
  //   case COMMODITY.EQUITY.id:
  //   case COMMODITY.TRUST.id:
  //     url = "Equity/Message/Chart"
  //     break
  //   // 先物、オプション
  //   case COMMODITY.FUTURE.id:
  //   case COMMODITY.OPTION.id:
  //     url = "Derivative/Message/Chart"
  //     break
  //   default:
  //     break
  // }
  return await API.auth_request("GET", url, params, headers)
}

const IndicatorChart = async (
  params = { ID: "EU-GDP-Y-F", TargetDate: "20200125" },
  headers?: object
) => {
  const url = "Message/IndicatorChart"
  return await API.auth_request("GET", url, params, headers)
}

const DelayChart = async (params?: object, headers?: object) => {
  return await API.auth_request("GET", "Message/DelayChart", params, headers)
}

export default {
  GetChartSession,
  Chart,
  IndicatorChart,
  DelayChart,
}
